import { collection, query, or, where } from "firebase/firestore";
import { auth } from "../firebase";
import { effectiveAccess } from "./policy";
const memberships = new Map();
export function setDirectoryMembership(clinicId, member) {
  memberships.clear();
  if (clinicId && member && auth.currentUser)
    memberships.set(clinicId, { uid: auth.currentUser.uid, member });
}
export function patientDirectory(db, clinicId) {
  const reference = collection(db, "clinics", clinicId, "patientIndex"),
    entry = memberships.get(clinicId),
    uid = auth.currentUser?.uid;
  if (
    entry?.uid === uid &&
    effectiveAccess(entry.member).patientScope === "all"
  )
    return reference;
  const id = uid || "__sin_sesion__";
  return query(
    reference,
    or(
      where("doctorId", "==", id),
      where("createdBy", "==", id),
      where("asignadoA", "==", id),
      where("doctorIds", "array-contains", id),
    ),
  );
}

export function directoryMembership(clinicId) {
  const value = memberships.get(clinicId);
  return value?.uid === auth.currentUser?.uid ? value.member : null;
}
export function agendaDirectory(db, clinicId) {
  const reference = collection(db, "clinics", clinicId, "citas"),
    member = directoryMembership(clinicId),
    uid = auth.currentUser?.uid || "__sin_sesion__";
  return member && effectiveAccess(member).agendaScope === "team"
    ? reference
    : query(
        reference,
        or(where("doctorId", "==", uid), where("createdBy", "==", uid)),
      );
}
